module.exports = "/assets/career/team/bartosz_kwiatek.png?Zjn2rJE";